import { useMemo } from 'react';

import useForm from '../utils/useForm';

const useReversePaymentForm = (onSubmit, readOnly) => {
  const fields = useMemo(
    () => [
      {
        title: 'Reverse Payment',
        fields: [
          {
            title: 'Void Payment',
            name: 'status',
            type: 'select',
            readOnly,
            options: [
              {
                value: 'void',
                label: 'Void',
              },
              { value: 'partial', label: 'Partial' },
              {
                value: 'unapplied',
                label: 'Unapplied',
              },
              { label: 'Cancelled', value: 'cancelled' },
            ],
            defaultValue: 'void',
          },
          {
            readOnly,
            title: 'Charge NSF',
            name: 'charge_nsf',
            type: 'checkbox',
            defaultValue: true,
          },
        ],
      },
    ],
    [readOnly]
  );

  return useForm({ fields, onSubmit });
};

export default useReversePaymentForm;
